import api from "./api";

const legal = {
  getLegal() {
    return api.get(`/legal-entities/`);
  },
  addLegal(args) {
    return api.post(`/legal-entities/`, args);
  },
  editLegal(args, id) {
    return api.patch(`/legal-entities/${id}`, args);
  },
  deleteLegal(id) {
    return api.delete(`/legal-entities/${id}`);
  },
};

export default legal;
